import type { LineItem } from '~/types/commercetools';

function getItemQty(product: LineItem): number {
  return product?.quantity ?? 0;
}

export const cartGetters = {
  getItemQty,
};
